import { useMemo } from 'react';

import { LifecycleStatus } from '@ndvr/portfolio-api';

import { useGetClientsForGlobalAccount } from 'views/client/client-queries';
import { useCommandCenterHouseholdProfile } from 'views/household/household-queries';
import {
    AccountGroupProfileWithAumIncluded,
    useListAccountGroupProfilesWithAumIncluded,
} from 'views/portfolio/account-aum-queries';

export const useHouseholdOverview = (globalAccountGUID: string) => {
    const {
        data: accountData,
        isLoading: isAccountDataLoading,
        isFetching: isAccountDataFetching,
    } = useCommandCenterHouseholdProfile(globalAccountGUID);
    const {
        data: clients = [],
        isLoading: isClientsLoading,
        isFetching: isClientsFetching,
    } = useGetClientsForGlobalAccount(globalAccountGUID);
    const {
        data: accountGroupProfilesData = [],
        isLoading: isAccountGroupProfilesLoading,
        isFetching: isAccountGroupProfilesFetching,
    } = useListAccountGroupProfilesWithAumIncluded(globalAccountGUID);

    const filteredAndSortedProfiles = useMemo(
        () =>
            accountGroupProfilesData.filter(
                (accountGroupProfile: AccountGroupProfileWithAumIncluded) =>
                    LifecycleStatus.ONBOARDING !== accountGroupProfile.accountGroup.lifecycleStatus,
            ),
        [accountGroupProfilesData],
    );

    const isLoading = isAccountDataLoading || isClientsLoading || isAccountGroupProfilesLoading;
    const isRefetching = isAccountDataFetching || isClientsFetching || isAccountGroupProfilesFetching;

    return {
        accountData,
        clients,
        accountGroupProfiles: filteredAndSortedProfiles,
        isLoading,
        isRefetching,
    };
};
